import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./UserList.css"
import AvatarRound from "../AvatarRound";

function UserList({ list, id_type, show_type }) {
    /*
    list:
          ID_User
         ,Name_User
         ,ID_Action
         ,Avatar

    */
    const stateSize = useSelector((state) => state.size);

    const [users, setUsers] = useState([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        if (list.length > 2) {
            setUsers(list.map(item => {
                return { item, Show: true }
            }));
        }
        else {
            setUsers(list.map(item => {
                return { item, Show: true }
            }));
        }
    }, [list]);

    function showAllUser(e, val) {
        e.stopPropagation();
        setShowAll(val);
    }

    return (
        <div>
            {users.filter(a => a.ID_Action !== null).length === 0 && (
                <div className='form_error'>Нет ответственных</div>
            )}
            {users.filter(a => a.ID_Action !== null).length > 0 && (

                stateSize.desktop === true ?
                    (
                        <>
                            {show_type === true && <div className="user_list_item_type"> {id_type === 1 ? ("Выполняет один из:") : ("Выполняет каждый из:")}</div>}

                            <div className="">
                                {list.filter(a => a.ID_Action !== null).map((user, index) => (
                                    showAll === true ? (
                                        <div key={user.ID_User} className="user_list_item">
                                            <div><AvatarRound img={user.Avatar} width={28} name={user.User_Name} /></div>
                                            <div className="ml-5" style={{ textDecoration: user.Completed === true ? "line-through" : "none" }}>
                                                <div className="user_list_item_title">{user.User_Name}</div>
                                                <div className="subtitle">{user.ID_Action === 1 ? 'Наблюдатель' : 'Исполнитель'}</div>
                                            </div>
                                        </div>
                                    ) : (
                                        index < 2 && (
                                            <div key={user.ID_User} className="user_list_item">
                                                <div><AvatarRound img={user.Avatar} width={28} name={user.User_Name} /></div>
                                                <div className="ml-5" style={{ textDecoration: user.Completed === true ? "line-through" : "none" }}>
                                                    <div className="user_list_item_title">{user.User_Name}</div>
                                                    <div className="subtitle">{user.ID_Action === 1 ? 'Наблюдатель' : 'Исполнитель'}</div>
                                                </div>
                                            </div>)
                                    )
                                ))}
                            </div>
                            {list.length > 2 && (
                                showAll === false ? (
                                    <div className="user_list_item_else" onClick={(e) => showAllUser(e, true)}>Показать еще {list.length - 2}</div>
                                ) : (
                                    <div className="user_list_item_else" onClick={(e) => showAllUser(e, false)}>Скрыть</div>
                                )
                            )}
                        </>
                    )
                    :
                    (
                        <>
                            {show_type === true && <div className="user_list_block_type"> {id_type === 1 ? ("Выполняет один из:") : ("Выполняет каждый из:")}</div>}

                            <div className="user_list_block">
                                {list.filter(a => a.ID_Action !== null).map((user, index) => (
                                    <div key={user.ID_User} className="user_list_item">
                                        <div><AvatarRound img={user.Avatar} width={28} name={user.User_Name} /></div>
                                        <div className="ml-5" style={{ textDecoration: user.Completed === true ? "line-through" : "none" }}>
                                            <div className="user_list_item_title">{user.User_Name}</div>
                                            <div className="subtitle">{user.ID_Action === 1 ? 'Наблюдатель' : 'Исполнитель'}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
            )}
        </div>
    )
}

export default UserList;